export const initBlockData = {
  title: "Promos",
  activeTitle: "Active",
  passedTitle: "Passed"
};

export const initEmptyBlockData = {
  title: "",
  activeTitle: "",
  passedTitle: ""
};
